import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookInputWrapper } from 'src/components/CookbookInputWrapper/CookbookInputWrapper';

export interface UniqueIdentifierControlProps {
  name: string;
  id: string;
}

export function UniqueIdentifierControl({
  name,
  id,
}: UniqueIdentifierControlProps): JSX.Element {
  const { errors, control } = useFormContext();
  const requiredMessage = 'Unique identifier is required';
  const isEmptyValue = (value: string): boolean | string =>
    value.trim() !== '' || requiredMessage;

  return (
    <CookbookInputWrapper
      name={name}
      id={id}
      maxLength={30}
      control={control}
      error={errors[name]}
      aria-label={name}
      inputSize="medium"
      blockWidth
      label="Enter a unique identifier *"
      rules={{
        required: requiredMessage,
        validate: {
          isEmpty: isEmptyValue,
        },
      }}
    />
  );
}
